import { showNotification, type NotificationTone } from '../notification';

const VALID_TONES = new Set<NotificationTone>(['info', 'warning', 'error']);

function resolveTone(raw: unknown): NotificationTone {
  const tone = String(raw ?? 'info').toLowerCase();
  if (VALID_TONES.has(tone as NotificationTone)) return tone as NotificationTone;
  return 'info';
}

export function runLogNotificationImplementation(data: {
  message?: string;
  detail?: string;
  tone?: string;
}) {
  const title = String(data.message ?? '').trim() || 'Notification';
  const detail = String(data.detail ?? '').trim();
  const tone = resolveTone(data.tone);

  showNotification({
    title,
    detail: detail || undefined,
    tone,
  });

  consoleFnForTone(tone)(`[graph] ${title}${detail ? ` — ${detail}` : ''}`);
}

function consoleFnForTone(tone: NotificationTone): (...args: unknown[]) => void {
  if (tone === 'error') return console.error.bind(console);
  if (tone === 'warning') return console.warn.bind(console);
  return console.info.bind(console);
}
